import React from 'react';
import styled from 'styled-components';
import Select, { components, OptionProps } from 'react-select';
import DateCheckboxList from './DateCheckboxList';  

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const Name = styled.span`
  min-width: 60px;
  color: ${({ theme }) => theme.colors.text};
  margin-right: 12px;
`;

// 커스텀 Option: 체크박스 + 라벨
const CheckboxOption = (props: OptionProps<any>) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      checked={props.isSelected}
      onChange={() => {}}
      style={{ marginRight: 8 }}
      tabIndex={-1}
      readOnly
      aria-label={props.label}
    />
    <span>{props.label}</span>
  </components.Option>
);

interface RoleAssignmentProps {
  names: string[];
  roles: string[];
  assignments: { [name: string]: string[] };
  onChange: (name: string, roles: string[]) => void;
}

const RoleAssignment: React.FC<RoleAssignmentProps> = ({ names, roles, assignments, onChange }) => {
  const options = roles.map(role => ({ value: role, label: role }));

  return (
    <div>
      <h4>😀 역할담당</h4>
      {names.map(name => (
        <Row key={name}>
          <Name>{name}</Name>
          <Select
            isMulti
            options={options}
            value={assignments[name]?.map(r => ({ value: r, label: r })) || []}
            onChange={selected =>
              onChange(name, selected.map(s => s.value))
            }
            placeholder="선택"
            components={{ Option: CheckboxOption }}
            closeMenuOnSelect={false}
            styles={{
              container: base => ({ ...base, minWidth: 200 }),
              control: base => ({ ...base, background: '#232323', borderColor: '#333', color: '#fff' }),
              menu: base => ({ ...base, background: '#232323', color: '#fff' }),
              multiValue: base => ({ ...base, background: '#ffb74d', color: '#232323' }),
            }}
          />
        </Row>
      ))}
    </div>
  );
};

export default RoleAssignment; 